import { getMeasureUnits } from "../../../services/stock";
import { createMeasureUnit, deleteMeasureUnit, updateMeasureUnit } from "../../../services/stock/measureUnit";

export default {
    namespaced: true,
    state: {
        list: []
    },
    getters: {
        list: state => state.list
    },
    mutations: {
        set: (state, payload) => state.list = payload,
        add: (state, payload) => state.list = [...state.list, payload],
        update: (state, payload) => {
            let list = [...state.list];
            let measureUnit = list.find(each => each.id == payload.id);
            let index = list.indexOf(measureUnit);
            list[index] = payload;
            state.list = [...list];
        },
        remove: (state, payload) => {
            let list = [...state.list];
            let measureUnit = list.find(each => each.id == payload.id);
            let index = list.indexOf(measureUnit);
            list.splice(index, 1);
            state.list = [...list];
        }
    },
    actions: {
        getAll(context) {
            return new Promise((resolve, reject) => {
                getMeasureUnits()
                    .then(response => {
                        context.commit("set", response.data);
                        resolve(response)
                    })
                    .catch(error => reject(error))
            });
        },
        store(context, payload) {
            return new Promise((resolve, reject) => {
                createMeasureUnit(payload)
                    .then(response => {
                        context.commit("add", response.data.record);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            }); 
        },
        update(context, payload) {
            return new Promise((resolve, reject) => {
                updateMeasureUnit(payload)
                    .then(response => {
                        context.commit("update", response.data.record);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            }); 
        },
        remove(context, payload) {
            return new Promise((resolve, reject) => {
                deleteMeasureUnit(payload)
                    .then(response => {
                        context.commit("remove", response.data.record);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            }); 
        },
    }
}